import L from "leaflet"
import "leaflet.markercluster"


const defaultIconClusterGroupCreateFunction = (cssName: string) => {
  return (cluster: any) => {
    // @ts-ignore
    return new L.DivIcon(L.extend({
      className: `leaflet-marker ${cssName}`,
      html: `
      <div style="${cluster.getAllChildMarkers()[0].options.smallImageBgUrl}"></div>​
      <span>${cluster.getChildCount()}</span>
    `,
    }, { iconSize: [50, 50] }))
  }
}

const priceIconClusterGroupCreateFunction = (cssName: string) => {

  return (cluster: any) => {
    const anyMarker = cluster.getAllChildMarkers().find((marker: any) => {
      return marker.options.priceInfo.price > 0
    })

    let minPrice = anyMarker ? anyMarker.options.priceInfo.price : 0

    cluster.getAllChildMarkers().forEach((marker: any) => {
      const priceInfo = marker.options.priceInfo
      if (priceInfo.price > 0 && priceInfo.price < minPrice) {
        minPrice = priceInfo.price
      }
    })

    let minPriceString = "?"
    if (minPrice) {
      minPriceString = minPrice.toLocaleString()
    }

    // @ts-ignore
    return new L.DivIcon(L.extend({
      className: `leaflet-marker ${cssName}`,
      html: `
      <div class="price-icon">${minPriceString} €</div>​<span>${cluster.getChildCount()}</span>
    `,
    }, { iconSize: [55, 25] }))
  }
}

export const createGroupIconFunction = (showPrice: boolean, cssName: string) => {
  return showPrice ? priceIconClusterGroupCreateFunction(cssName) : defaultIconClusterGroupCreateFunction(cssName)
}

export const createMarkerIcon = (
  showPrice: boolean,
  cssName: string,
  smallImageBgUrl: string,
  priceInfo: { minimumPriceStr: string }) => {

  const markerCss = `leaflet-marker ${cssName}`

  if (showPrice) {
    // @ts-ignore
    return L.divIcon(L.extend({
      html: `<div class="price-icon"> ${priceInfo.minimumPriceStr} €</div>`,
      className: markerCss,
      iconSize: [55, 25],
    }))
  } else {
    // @ts-ignore
    return L.divIcon(L.extend({
      html: `<div style="${smallImageBgUrl}"></div>​`,
      className: markerCss,
      iconSize: [50, 50],
    }))
  }
}
